import React, { useEffect, useState } from "react";
import { getAttritionData } from "../../../../../api";
import { dateFormatter } from "../../../../../components/helper/helper";
import MenuIcon40 from "../../../../assets/svg/icons/common/MenuIcon40";
import TrendDown24 from "../../../../assets/svg/icons/common/TrendDown24";
import SkeletonLoader from "../../../../components/skeleton-loader";
import SlidingTab from "../../../../components/SlidingTab/SlidingTab";
import useDashboardStore from "../../../../stores/dashboard";
import MerchantNameLink from "../../../../components/MerchantNameLink";
import styles from "./style.module.scss";

const formatNumber = (num) => {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + "B";
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + "M";
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + "K";
  }
  return num.toString();
};

const MerchantAttrition = () => {
  const [merchantAttrition, setMerchantAttrition] = useState([]);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("top");

  const filterStartDate = useDashboardStore((s) => s.filterData.startDate);
  const filterEndDate = useDashboardStore((s) => s.filterData.endDate);

  useEffect(() => {
    const fetchAttritionData = async () => {
      setLoading(true);
      const response = await getAttritionData({
        start_date: filterStartDate,
        end_date: filterEndDate,
        type: type,
      });
      setMerchantAttrition(response.data);
      setLoading(false);
    };
    fetchAttritionData();
  }, [filterStartDate, filterEndDate, type]);
  return (
    <div className={styles.activeMerchant}>
      <div className={styles.activeMerchantHeader}>
        <div className={styles.activeMerchantHeaderContent}>
          <p className={styles.activeMerchantHeaderTitle}>Merchant Attrition</p>
          <p className={styles.activeMerchantHeaderDate}>
            {new Date(filterStartDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            })}{" "}
            -{" "}
            {new Date(filterEndDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            })}
          </p>
        </div>

        <div className={styles.activeMerchantHeaderActions}>
          <SlidingTab
            options={["Top", "Low"]}
            onChange={(value) => {
              setType(value.toLowerCase());
            }}
          />
        </div>
      </div>
      {loading && (
        <div className={styles.activeMerchantList}>
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className={styles.activeMerchantListItem}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  width: "100%",
                }}
              >
                <SkeletonLoader
                  variant="rectangular"
                  height="20px"
                  width="100%"
                  style={{ borderRadius: "8px" }}
                />
                <SkeletonLoader
                  variant="rectangular"
                  height="16px"
                  width="75px"
                  style={{ borderRadius: "8px" }}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && (
        <>
          {merchantAttrition?.length > 0 ? (
            <div className={styles.activeMerchantList}>
              {merchantAttrition.map((merchant, index) => (
                <div key={index} className={styles.activeMerchantListItem}>
                  <div className={styles.activeMerchantListItemContent}>
                    <p className={styles.activeMerchantListItemTitle}>
                      <MerchantNameLink powerappId={merchant.powerapp_id}>
                        {merchant.dba}
                      </MerchantNameLink>
                    </p>
                    <p className={styles.activeMerchantListItemDescription}>
                      Closed {dateFormatter(merchant.close_date)}
                    </p>
                  </div>

                  <div className={styles.amountContainer}>
                    <p className={styles.amountValue}>
                      ${formatNumber(merchant.total_sales)}
                    </p>
                  </div>

                  <div className={styles.trendContainer}>
                    <span className={styles.trendIcon}>
                      <TrendDown24 />
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.emptyContainer}>
              <div className={styles.iconBox}>
                <MenuIcon40 />
              </div>

              <p className={styles.emptyTitle}>
                This card will display merchants who closed accounts, sorted by
                total volume lost
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MerchantAttrition;
